import NextLink from 'next/link';
import {Flex, Text, Link, FlexProps} from '@chakra-ui/react';
import {useRouter} from 'next/router';

import {useTranslate} from '@eksab/i18n';
import {getCountry} from '@eksab/util';

import {TriviaIcon} from '../icons/TriviaIcon';
import {useTriviaStore} from '../state';

export const MoreTriviaGames = (props: FlexProps) => {
  return (
    <Flex
      pos="sticky"
      bottom="0"
      roundedTop="2xl"
      width="full"
      h="76px"
      bgColor="white"
      borderTop="1px solid #E5E5E5"
      borderInline="1px solid #E5E5E5"
      justifyContent="center"
      alignItems="center"
      {...props}
    >
      <TriviaListingLink />
    </Flex>
  );
};

export const TriviaListingLink = () => {
  const {locale} = useRouter();

  const t = useTranslate();
  const returnURL = useTriviaStore((state) => `/play/${state.game?.route}`);
  const prevAppLanguage = useTriviaStore((state) =>
    state.prevAppLanguage ? `${state.prevAppLanguage}-${getCountry(locale)}` : undefined,
  );

  return (
    <Link
      as={NextLink}
      href={returnURL}
      locale={prevAppLanguage}
      passHref
      px="6"
      py="3"
      gap="6"
      rounded="full"
      display="flex"
      alignItems="center"
      bgColor="#FAFAFA"
      borderWidth="1px"
      borderColor="#DAE2DA"
    >
      <Text fontSize="xs" fontWeight="bold">
        {t('trivia.more-games')}
      </Text>
      <TriviaIcon fill="green.400" />
    </Link>
  );
};
